export const truncateFileName = (fileName: string, numOfChars: number): string =>
  fileName.length > numOfChars
    ? fileName.slice(0, Math.ceil(numOfChars / 2)) +
      '...' +
      fileName.slice(-Math.floor(numOfChars / 2))
    : fileName;
